<script setup lang="ts"></script>

<template lang="pug">
section(
  ).w-full.relative.flex.flex-center.overflow-hidden.pb-8
  slot
</template>
